// web/src/store/phone/_env.ts —— 内部：WSS 地址推导 / SIP 域缓存 / 解析 / 运行期引擎选择
// 拆自 web/src/store/phone.ts 的同名分区（内容原样搬运）；由 web/src/store/phone.ts 以 export * 聚合，导出面对调用方不变。

import { Invitation, Inviter, Registerer, RegistererState, Session, SessionState, TransportState, UserAgent, UserAgentRegisteredOptionTags } from 'sip.js';
import { getFsDomain, getSysSettings } from '../../api/sysSettings';
import { getTelephonyEngine } from '../../api/fsSettings';
import { resolveSipSignal } from '../../utils/sipSignal';

import { rt } from './_state';


// SIP 信令地址：按页面协议二选一（https→wss / http→ws），推导与回落口径见 utils/sipSignal.ts
export const sipWss: string = resolveSipSignal();

function sipHost() {
  try {
    return new URL(sipWss).hostname;
  } catch {
    return window.location.hostname;
  }
}

export async function resolveSipDomain(): Promise<string> {
  if (rt.cachedFsDomain === null) {
    try {
      rt.cachedFsDomain = (await getFsDomain()) || '';
    } catch {
      rt.cachedFsDomain = '';
    }
  }
  return rt.cachedFsDomain || import.meta.env.VITE_SIP_DOMAIN || sipHost();
}

export function parseUser(session: Session): string {
  const id: any = session.remoteIdentity;
  return id?.uri?.user || id?.displayName || '';
}

/** 解析当前引擎（首次向服务端取，失败回落构建期值，结果缓存）。 */
export async function resolveEngine(): Promise<'freeswitch' | 'zitch'> {
  if (rt.runtimeEngine) return rt.runtimeEngine;
  try {
    const info = await getTelephonyEngine();
    rt.runtimeEngine = info.engine === 'zitch' ? 'zitch' : 'freeswitch';
  } catch {
    rt.runtimeEngine = import.meta.env.VITE_TELEPHONY_ENGINE === 'zitch' ? 'zitch' : 'freeswitch';
  }
  return rt.runtimeEngine;
}
